/**
 * Хелперы для работы с кодом генерации элементов
 */
import { getCenter } from './elementUtils';

export const createCodeHelpers = (ElementFactory, findNearestConnectionPoint) => ({
  textInside: (el, content = 'Текст', opt = {}) => {
    const { dx = 0, dy = 0, fontSize, fontFamily, fill } = opt;
    const c = getCenter(el);
    const t = ElementFactory.text(c.x + dx, c.y + dy, content);
    if (fontSize) t.fontSize = fontSize;
    if (fontFamily) t.fontFamily = fontFamily;
    if (fill) t.fill = fill;
    t.attachedToElement = el.id;
    return t;
  },

  arrowBetween: (a, b) => {
    if (!a || !b) return null;
    const ac = getCenter(a), bc = getCenter(b);
    const s = findNearestConnectionPoint(bc.x, bc.y, [a], null, Infinity);
    const e = findNearestConnectionPoint(ac.x, ac.y, [b], null, Infinity);
    return ElementFactory.arrow(
      s?.point?.x ?? ac.x,
      s?.point?.y ?? ac.y,
      e?.point?.x ?? bc.x,
      e?.point?.y ?? bc.y,
      s ? { elementId: a.id, side: s.point.side } : null,
      e ? { elementId: b.id, side: e.point.side } : null
    );
  }
});
